/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentFileContent
 */
export interface AttachmentFileContent {
    /**
     * 
     * @type {string}
     * @memberof AttachmentFileContent
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentFileContent
     */
    buffer?: object;
    /**
     * 
     * @type {string}
     * @memberof AttachmentFileContent
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentFileContent
     */
    name: string;
}

/**
 * Check if a given object implements the AttachmentFileContent interface.
 */
export function instanceOfAttachmentFileContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AttachmentFileContentFromJSON(json: any): AttachmentFileContent {
    return AttachmentFileContentFromJSONTyped(json, false);
}

export function AttachmentFileContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentFileContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'buffer': !exists(json, 'buffer') ? undefined : json['buffer'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'name': json['name'],
    };
}

export function AttachmentFileContentToJSON(value?: AttachmentFileContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'buffer': value.buffer,
        'note': value.note,
        'name': value.name,
    };
}

